const WIDGET_SELECTOR = ".cf-turnstile"
const SCRIPT_ID = "turnstile-script"

window.renderTurnstile = (root) => {
  if (!root) {
    return
  }

  if (!window.turnstile) {
    const script = document.getElementById(SCRIPT_ID)

    script?.addEventListener("load", () => window.renderTurnstile(root), {
      once: true,
    })

    return
  }

  for (const widget of root.querySelectorAll(WIDGET_SELECTOR)) {
    if (widget.dataset.turnstileWidgetId) {
      continue
    }

    widget.dataset.turnstileWidgetId = window.turnstile.render(widget)
  }
}

window.resetTurnstile = (root) => {
  if (!root || !window.turnstile) {
    return
  }

  for (const widget of root.querySelectorAll(WIDGET_SELECTOR)) {
    const widgetId = widget.dataset.turnstileWidgetId

    // Implicitly rendered widgets carry no id, so they are reset by element
    if (!widgetId && widget.children.length === 0) {
      continue
    }

    window.turnstile.reset(widgetId || widget)
  }
}
